import {
  dropdownOptionTemplate,
  optionElementTemplate,
  autoCompleteChip,
} from "/WebInterface/new-ui/modules/tag-input/template.js";
import AutocompleteTemplate from "/WebInterface/new-ui/modules/web-components/autocomplete-input/template.js";
import { t } from "/WebInterface/new-ui/modules/localizations/localizations.js";
import { _$ } from "/WebInterface/new-ui/assets/js/utils/dom.js";

export default class TagInput {
  attach = ({
    input,
    options,
    onInputChange = () => {},
    onClose = () => {},
    helperText,
  }) => {
    const targetedInput = _$(input);

    const dataValidate = targetedInput.attr("data-validate");
    const dataMarkError = targetedInput.attr("data-mark-error");
    const dataInlineError = targetedInput.attr("data-inline-error");

    const name = targetedInput.attr("name");
    const id = targetedInput.attr("id");
    targetedInput
      .el()
      .insertAdjacentHTML("afterend", AutocompleteTemplate({ id }));
    targetedInput.remove();

    const autoCompleteWrapper = _$(`#${id}`);
    const hiddenSelect = autoCompleteWrapper.find("select", true);
    const insertedInput = autoCompleteWrapper.find("input");
    const inputWrapper = autoCompleteWrapper.find(".autocomplete-input");
    const autocompleteOptionDropdown = autoCompleteWrapper.find(
      ".autocomplete-input-options",
      true
    );

    if (dataValidate) {
      _$(hiddenSelect).attr("data-validate", dataValidate);
    }
    if (dataMarkError) {
      _$(hiddenSelect).attr("data-mark-error", dataMarkError);
    }
    if (dataInlineError) {
      _$(hiddenSelect).attr("data-inline-error", dataInlineError);
    }

    _$(hiddenSelect).attr("name", name);

    this.eventsToClean = [];

    inputWrapper.on("click", () => {
      insertedInput.el().focus();
    });

    this.eventsToClean.push(() => {
      inputWrapper.off("click", () => {
        insertedInput.el().focus();
      });
    });

    const onUserInput = (e) => {
      _$(autocompleteOptionDropdown).removeClass("is-hidden");
      onInputChange(e);
    };

    insertedInput.on("focus", () => {
      _$(autocompleteOptionDropdown).removeClass("is-hidden");
      onUserInput({ target: insertedInput[0] });
    });
    this.eventsToClean.push(() => {
      insertedInput.off("focus", () => {
        _$(autocompleteOptionDropdown).removeClass("is-hidden");
      });
    });

    insertedInput.on("blur", () => {
      // _$(autocompleteOptionDropdown).addClass("is-hidden");
      // onClose();
    });

    this.eventsToClean.push(() => {
      insertedInput.off("blur", () => {
        _$(autocompleteOptionDropdown).addClass("is-hidden");
        onClose();
      });
    });

    insertedInput.on("input", onUserInput);

    this.eventsToClean.push(() => {
      insertedInput.off("input", onUserInput);
    });

    const onKeyUp = (e) => {
      if (e.key === "Escape") {
        if (insertedInput.val() === "") {
          _$(autocompleteOptionDropdown).addClass("is-hidden");
          onClose();
        } else {
          insertedInput.val("");
          onUserInput({ target: insertedInput[0] });
        }
        e.preventDefault();
        e.stopPropagation();
        return false;
      }
    };

    const onKeyDown = (e) => {
      const autocompleteOptionDropdown = autoCompleteWrapper.find(
        ".autocomplete-input-options",
        true
      );
      let currentOption;
      if (autocompleteOptionDropdown) {
        currentOption = _$(autocompleteOptionDropdown).find(
          ".highlighted",
          true
        );
      }
      if (e.key === "ArrowUp") {
        const allOpts = autocompleteOptionDropdown.querySelectorAll(
          ".autocomplete-option"
        );
        const lastOption = allOpts[allOpts.length - 1];
        const nextOption =
          currentOption && currentOption.parentElement.previousElementSibling
            ? currentOption.parentElement.previousElementSibling.querySelector(
                ".autocomplete-option:last-child"
              )
            : lastOption;
        if (currentOption !== nextOption) {
          if (currentOption) currentOption.classList.remove("highlighted");
          if (nextOption && nextOption.getAttribute("option-name"))
            nextOption.classList.add("highlighted");
        }
        e.preventDefault();
        return false;
      } else if (e.key === "ArrowDown") {
        const nextOption =
          currentOption && currentOption.parentElement.nextElementSibling
            ? currentOption.parentElement.nextElementSibling.querySelector(
                ".autocomplete-option"
              )
            : _$(autocompleteOptionDropdown).find(".autocomplete-option", true);
        if (currentOption !== nextOption) {
          if (currentOption) currentOption.classList.remove("highlighted");
          if (nextOption && nextOption.getAttribute("option-name"))
            nextOption.classList.add("highlighted");
        }
        e.preventDefault();
        return false;
      } else if (e.key === "Backspace") {
        if (insertedInput.val() === "") {
          const removeBtn =
            insertedInput.el().parentElement.previousElementSibling &&
            insertedInput
              .el()
              .parentElement.previousElementSibling.querySelector(
                ".icon-remove"
              );
          if (removeBtn) {
            removeBtn.click();
          }
          e.preventDefault();
          return false;
        }
      } else if (e.key === "Enter") {
        if (autocompleteOptionDropdown) {
          currentOption = _$(autocompleteOptionDropdown).find(
            ".highlighted",
            true
          );
          if (currentOption && currentOption.getAttribute("option-name")) {
            currentOption.parentElement.click();
          }
        }
      }
    };

    insertedInput.on("keydown", onKeyDown);

    this.eventsToClean.push(() => {
      insertedInput.off("keydown", onKeyDown);
    });

    insertedInput.on("keyup", onKeyUp);

    this.eventsToClean.push(() => {
      insertedInput.off("keyup", onKeyUp);
    });

    const handleClick = (e) => {
      const isClickInside =
        autoCompleteWrapper.el()?.contains(e.target) ||
        e.target?.classList?.contains("autocomplete-option");
      if (!isClickInside) {
        _$(autocompleteOptionDropdown).addClass("is-hidden");
        onClose();
      }
    };

    document.addEventListener("click", handleClick);
    this.eventsToClean.push(() => {
      document.removeEventListener("click", handleClick);
    });

    if (helperText) {
      autocompleteOptionDropdown.insertAdjacentHTML(
        "beforeend",
        dropdownOptionTemplate({
          label: utils.sanitizePure(decodeURIComponent(helperText)),
        })
      );
    }

    this.renderOptions({
      id,
      autoComplete: autoCompleteWrapper,
      options,
    });

    return autoCompleteWrapper;
  };

  getOptionsList = (options) => {
    if (typeof options === "string") {
      return options.split(",").map((option) => {
        return { label: option, value: option };
      });
    }

    if (Array.isArray(options)) {
      return options;
    }

    return [];
  };

  renderChips = ({ autoComplete = null, id }) => {
    const autoCompleteWrapper = autoComplete || _$(`#${id}`);
    const inputWrapper = autoCompleteWrapper.find(".autocomplete-input");
    const autocompleteOptionDropdown = autoCompleteWrapper.find(
      ".autocomplete-input-options",
      true
    );
    const hiddenSelect = autoCompleteWrapper.find("select", true);

    const selectedOptions = autoCompleteWrapper
      .find("select option[selected='true']")
      .sel();

    _$(autocompleteOptionDropdown).find(`p`).removeClass("selected");

    selectedOptions.forEach((option) => {
      const value = _$(option).attr("value");
      const label = _$(option).text();

      _$(autocompleteOptionDropdown)
        .find(`p[option-name="${value}"]`)
        .addClass("selected");

      const hasSelectedOptionChip = autoCompleteWrapper.find(
        `.autocomplete-input [value="${value}"]`,
        true
      );

      if (!hasSelectedOptionChip) {
        const chipWrapper = _$("<div>");
        chipWrapper
          .el()
          .insertAdjacentHTML("beforeend", autoCompleteChip({ value, label }));
        inputWrapper
          .el()
          .insertBefore(
            chipWrapper.el(),
            inputWrapper.find(".is-flex-grow-1", true)
          );

        chipWrapper.find(".icon-remove").on("click", (e) => {
          chipWrapper.remove();
          _$(autocompleteOptionDropdown)
            .find(`[option-name="${label}"]`)
            .removeClass("selected");
          e.stopPropagation();
          _$(hiddenSelect).find(`[value="${value}"]`).remove();
        });
      }
    });
  };

  updateOptions = ({ autoComplete = null, id, options, helperText }) => {
    const autoCompleteWrapper = autoComplete || _$(`#${id}`);
    if (!autoCompleteWrapper) return;
    const autocompleteOptionDropdown = autoCompleteWrapper.find(
      ".autocomplete-input-options",
      true
    );

    _$(autocompleteOptionDropdown).html("");

    if (helperText) {
      autocompleteOptionDropdown.insertAdjacentHTML(
        "beforeend",
        dropdownOptionTemplate({
          label: utils.sanitizePure(decodeURIComponent(helperText)),
        })
      );
    }

    this.renderOptions({ id, autoComplete, options });
  };

  updateSelectedOption = ({ autoComplete, id, options }) => {
    const autoCompleteWrapper = autoComplete || _$(`#${id}`);

    if (!autoCompleteWrapper.el()) {
      return;
    }

    const hiddenSelect = autoCompleteWrapper.find("select");
    const autoCompleteChips = autoCompleteWrapper.find(
      ".autocomplete-selected-option"
    );

    const optionsList = this.getOptionsList(options);
    hiddenSelect.html("");

    autoCompleteChips.sel().forEach((chip) => {
      chip.parentElement?.remove();
    });

    optionsList.forEach((option) => {
      const { label, value } = option;

      if (!label) {
        return;
      }

      hiddenSelect
        .el()
        .insertAdjacentHTML(
          "beforeend",
          optionElementTemplate({ label, value })
        );
    });

    this.renderChips({ autoComplete, id });
  };

  destroy = () => {
    if (this.eventsToClean) {
      this.eventsToClean.forEach((evt) => {
        evt();
      });
    }
  };
  renderOptions = ({ autoComplete, id, options }) => {
    const autoCompleteWrapper = autoComplete || _$(`#${id}`);
    const hiddenSelect = autoCompleteWrapper.find("select", true);
    const insertedInput = autoCompleteWrapper.find("input");
    const autocompleteOptionDropdown = autoCompleteWrapper.find(
      ".autocomplete-input-options",
      true
    );

    const optionsList = this.getOptionsList(options);

    optionsList.forEach((option) => {
      const { label, value } = option;
      const optionAlreadySelected = _$(hiddenSelect).find(
        `[value="${value}"]`,
        true
      );

      const optionWrapper = _$("<div>");
      optionWrapper.el().insertAdjacentHTML(
        "beforeend",
        dropdownOptionTemplate({
          name: utils.sanitizePure(decodeURIComponent(label)),
          label: utils.sanitizePure(decodeURIComponent(label)),
        })
      );
      autocompleteOptionDropdown.append(optionWrapper.el());

      if (optionAlreadySelected) {
        optionWrapper.find("p").addClass("selected");
      }

      optionWrapper.on("click", (e) => {
        if (optionWrapper.find("p").hasClass("selected")) {
          return;
        }

        hiddenSelect.insertAdjacentHTML(
          "beforeend",
          optionElementTemplate({ label, value })
        );

        _$(autocompleteOptionDropdown)
          .find(`[option-name="${label}"]`)
          .addClass("selected");

        // insertedInput.el().focus();
        insertedInput.val("");

        this.updateOptions({
          autoComplete,
          helperText: t("typeInASearchTerm"),
        });

        this.renderChips({ autoComplete, id });
        e.stopPropagation();
      });
    });
  };

  getSelectedOptions = ({ autoComplete, id }) => {
    const autoCompleteWrapper = autoComplete || _$(`#${id}`);

    const selectedOptions = autoCompleteWrapper
      .find("select option[selected='true']")
      .sel();

    return selectedOptions.map((option) => {
      return { value: option.value, label: _$(option).text() };
    });
  };
}
